export class LicenseContentENUS {
    public static licenseContentENUS = `
    <h2>
    License Agreement Chapps
    </h2>

    <p>The terms of use of this License Agreement form part of the Agreement between you and Chapps N.V./S.A., 1000 Brussels, Picardstraat 7 box 100, and with company number 0599.927.776 (hereinafter referred to as “Chapps”).</p>

    <p>By downloading, accessing or using the Chapps Applications in any way, you expressly acknowledge that you have read and understood 
    the terms of use of this License Agreement, as well as the Terms and Conditions and Privacy Statement, and that you expressly agree to 
    abide by all of their provisions.<br/>
    You also expressly acknowledge that these documents, together with the service proposal signed by you, form an integral part of the entire 
    Agreement between the parties, and cannot be interpreted separately.</p>

    <p>All documents of Chapps are available at <a href="http://www.chapps.com">www.chapps.com</a>, or can be retrieved in PDF format via 
    <a href="mailto:info@chapps.com">info@chapps.com</a></p>


    <h3>1. License</h3>

    <p>Chapps hereby grants you a personal, non-transferable, non-exclusive and non-sublicensable licence to download, access and use the 
    Applications on any device you own or control, in accordance with the terms of this Licence Agreement, the General Terms and Conditions 
    and the Privacy Statement.</p>


    <h3>2. Third-Party Beneficiaries</h3>

    <p>Chapps warrants that it will provide the Website and the Apps in a manner consistent with general industry standards, reasonably
    applicable to the provision thereof.</p>

    <p>You also acknowledge and agree that the distribution partners and their subsidiaries operating under license with Chapps are third-party 
    beneficiaries of this License Agreement and that upon your acceptance of this License Agreement, such distribution partners have the right 
    (and will be deemed to have accepted this right) to enforce the License Agreement against you as a third-party beneficiary thereof.</p>


    <h3>3. Responsibilities of Chapps</h3>

    <p>Chapps warrants that the Chapps Applications will be made available in a manner consistent with the general industry standards reasonably 
    applicable to the making available of such Chapps Applications.<br/>
    The Chapps Applications are made available "as is" and "as available", including all defects and without any warranty of any kind.</p>

    <p>Chapps will host the Applications on a secure data centre and monitor and manage their performance. Chapps may change the Applications at 
    any time, including, but not limited to, the user interface and general layout of the screens.</p>


    <h3>4. Using the Chapps Applications</h3>
    
    <p>Use of the Applications does not include the supply of any mobile device or other necessary equipment to use it. To use the Applications, 
    you need an Internet connection and appropriate telecommunication links. We carry no responsibility or liability for any telephone or other 
    costs you may incur.</p>

    <p>Chapps' permission to use the Applications is subject to your compliance with these terms and conditions and the following restrictions:</p>
    <ol style="list-style-type: lower-alpha;">
    <li>You may not access or in any way exploit any of the underlying data, code, content or other material provided by Chapps  in connection with 
    the Applications; </li>
    <li>You may not edit, remove, alter, tamper with, or in any way change the Applications or any part of them;</li>
    <li>You may not copy, distribute, communicate to the public, sell, rent or otherwise use the Applications in any other way as permitted 
    (nor may you authorize others to do so);</li>
    <li>You may not distribute or make available the Applications over a network that would allow them to be used by multiple devices at the same time;</li>
    <li>You may not remove, alter or replace any copyright, trademark, trade name, logo or other indication of origin on the Applications, nor may you allow 
    the Applications for the product to appear as belonging to anyone other than Chapps or use any automated computer program or automated computer 
    application to scan, copy, index, sort or otherwise improperly use the Applications or any part thereof;</li>
    <li>You agree not to decrypt any underlying software or circumvent any technological protection contained herein;</li>
    <li>You must comply with all laws and regulations when using the Applications and may not use the Applications for illegal or unlawful purposes;</li>
    <li>You may not use the Applications in any way that could harm or be detrimental to Chapps' business activities;</li>
    <li>You may not, in the course of your use of the Applications, transmit material that is defamatory, offensive or otherwise objectionable;</li>
    <li>You may not, during the use of the Applications, pretend to be any other person or body, or to misrepresent any relationship with any person or organ;</li>
    <li>You must not use the Applications in any manner that could disable, damage, overload, weaken, compromise, or impair Chapps systems or security or that could 
    interfere with the use of other users;</li>
    <li>You may not infringe our intellectual property rights or those of any third party in connection with your use of the Applications.</li>
    </ol>

    <p>If you choose or are assigned a user identification code, password or any other piece of information as part of our security procedures, you must treat 
    that information confidentially and not disclose it to any third party.<br/>
    We have the right at any time to deactivate a user identification code or password, whether you have chosen it or it has been assigned by us, if in our 
    opinion you do not comply with any of the provisions of these Licensing Terms.
    </p>

    <p>You are solely responsible for the accuracy, quality, integrity, legality, reliability and appropriateness of the data you enter or add.</p>

    <p>You must ensure that no disruptive computer program code, virus, denial of service, or spam attack, worm, Trojan horse, authorization key, 
    license control device, or software lock is introduced by you or anyone authorized by you to use the Applications.</p>

    <p>You acknowledge that unauthorized use of the Applications may cause irreparable damage to Chapps and/or its affiliates or licensors. Accordingly, in the event 
    of such unauthorized use, Chapps, its affiliates and/or licensors will have the right, in addition to any other remedies available to them, to have an immediate 
    injunction issued against you, prohibiting any further use of the Applications. In addition, you may be subject to prosecution and payment of damages.</p>

    <p>Your right to use the Applications will expire immediately upon breach of any provision of this License Agreement. In such a case, Chapps reserves the right to
    block your access to, or use of, the Applications.</p>


    <h3>5. Disclaimer of Warranties</h3>

    <p>All terms, conditions, promises or warranties other than those expressly accepted in this License Agreement are rejected by Chapps.</p>

    <p>Although we make every effort to make the Applications available 24 hours a day, we will not be liable if, for any reason, they are unavailable for any period 
    of time.</p>

    <p>We do not guarantee that your access to the Applications will be uninterrupted, timely or error-free. Given the nature of the Internet, such a guarantee is 
    not possible. Chapps is not responsible for delays, disruptions to delivery or other damage resulting from problems with the Internet or electronic communication. 
    Regular maintenance and the introduction of new facilities and functions by Chapps may also affect the availability of the Applications.</p>

    <p>Access to the Applications may be temporarily or permanently suspended or revoked at any time without notice to you personally or to all users. We may also, for 
    any reason, impose restrictions on the duration and manner of use of any part of the Applications. If we impose restrictions on you personally, you should not attempt 
    to use the Applications under any other name or user or on any other mobile device.</p>

    <p>We do not guarantee that the Applications will be compatible with all the hardware and software you use.</p>

    <p>While we make every effort to ensure that the information and materials on the Applications are accurate, Chapps makes no guarantee or promise, express or implied, 
    that it is complete, accurate, up-to-date, or suitable for any particular purpose.</p>

    <p>Your use of the Applications is entirely at your own risk. You are responsible for protecting data stored on the device (computer, tablet, smartphone, etc.) used by 
    you to access or use the Applications and Chapps assumes no liability whatsoever for any loss of or damage to such data.</p>

    <p>Furthermore, Chapps will not be liable to you for any content of the Applications that may be defamatory, offensive, or otherwise objectionable.</p>

    <p>In general, Chapps makes no promises or guarantees that the Applications will meet your requirements and be suitable for a particular purpose, that they will work 
    continuously or that they will be safe or free of errors, malfunctions or defects.</p>


    <h3>6. Limitation of Liability</h3>

    <p>Except as otherwise provided for in this License Agreement, neither Chapps nor any of its authors, developers, licensors or distributors will be liable to you for 
    any damages arising out of the use or misuse of the Applications.</p>
    <p>This limitation of liability includes, but is not limited to, the following:</p>
    <ol style="list-style-type: lower-alpha;">
    <li>Any damage to, or viruses or any other code having a harmful effect on, equipment (including, but not limited to, your mobile device), software, 
    data or other property resulting from your downloading, installing, accessing or using the Applications or obtaining any material from, or by virtue of, 
    the use of the Applications;</li>
    <li>Damage arising from any inaccuracy or incompleteness in the content of the Applications, or any loss, damage, cost or expense of any kind incurred 
    by you in connection with your access to, use of or inability to use the Applications or any of their content;</li>
    <li>Damage resulting from personal injury, incidental, special, indirect or consequential damage, including, but not limited to, damage caused by loss 
    of profits, loss of data, business interruption or any other commercial damage or losses arising out of, or in connection with, your use of, or inability 
    to use, the Applications;</li>
    <li>Damage resulting from actions by third parties;</li>
    </ol>

    <p>These limitations of our liability apply regardless of whether such damage results from the use or misuse of, and/or reliance on, the Applications or 
    from the inability to open or use the Applications or from any interruption, suspension or discontinuance of the Applications.</p>

    <p>You should always seek professional advice before making decisions recommended by the Applications or about information obtained through Chapps that 
    could have legal or financial implications. Chapps accepts no liability whatsoever for any damage incurred as a result of failure to obtain appropriate 
    professional information or advice.</p>

    <p>In no event shall Chapps' liability exceed the amounts paid by you in the 12-month period preceding the event giving rise to such claim.</p>


    <h3>7. Apple’s Warranties and Liabilities</h3>

    <p>You recognise that:</p>
    <ul style="list-style: lower-alpha">
    <li>Apple is not responsible for the Applications or their content;</li>
    <li>Apple has no obligation to provide maintenance and support services for the Applications;</li>
    <li>In the event that the Applications fail to fulfil any warranty given under this License Agreement, 
    you may notify Apple and Apple will refund the purchase price for the Applications to you;</li>
    <li>Apple, to the extent permitted by relevant law, has no warranty of any kind with respect to the Applications and will not be responsible for any claims, 
    losses, obligations, damages, costs or expenses attributable to any failure to comply with any warranty;</li>
    <li>Apple will not be responsible for intervening in any action brought against you or any third party in respect of the Applications or your possession 
    and/or use of them, including, but not limited to: (i) claims arising out of product liability; (ii) any claim that the Applications would not meet any relevant 
    requirement imposed by law or regulation; and (iii) claims arising out of consumer protection legislation and similar legislation;</li>
    <li>In the event that a third party were to claim that the Applications or your possession and use of them would infringe that third party's intellectual property 
    rights, Apple would not be responsible for investigating, defending, settling and nullifying any such alleged infringement of intellectual property rights.</li>
    </ul>

    <p>
    The provisions of this article shall in no event prevent, disrupt, mitigate or otherwise adversely affect the validity, application and enforceability 
    of the Disclaimer of Warranties and the Limitation of Liability, as set forth in Articles 5 and 6 of this License Agreement.
    </p>


    <h3>8. Intellectual Property</h3>

    <p>All intellectual property rights including, but not limited to, copyright (including computer software copyright), patents, trademarks or trade names, 
    design rights, database rights, know-how, trade secrets and rights of trust in the Applications (together the "Intellectual Property Rights") are owned 
    or licensed by Chapps.</p>

    <p>You acknowledge that your rights in the Applications are licensed to you (and not sold or otherwise transferred to you) and that by using the Applications
    you do not acquire any ownership rights or interests in, or relating to, the Applications or the Intellectual Property Rights.</p>

    <p>The names and logos of Chapps and of the Applications are trademarks of Chapps or third parties and no right or license is granted to use them for 
    personal purposes.</p>


    <h3>9. Indemnification</h3>

    <p>You agree to fully and effectively indemnify and hold harmless Chapps and its affiliates, officers, directors, shareholders,
    agents and employees, from all actions, claims and proceedings made by any third party arising in connection with your
    use of the Website or Apps, as well as for all costs, damages and expenses (including, without limitation, legal fees)
    connected therewith.</p>


    <h3>10. Authorisation for processing personal data</h3>

    <p>Certain features of the Applications may require certain personal data to be processed by Chapps.</p>

    <p>Chapps takes your privacy seriously and undertakes to treat the personal data it processes with due care.</p>

    <p>By entering into this License Agreement, you expressly consent to Chapps processing your personal data provided through the Applications 
    in accordance with the provisions of its Privacy Policy, which, together with the other documents, forms an integral part of the Agreement 
    between Chapps and yourself.</p>


    <h3>11. Changes</h3>

    <p>Chapps may amend these License Terms in due course.<br/>
    We always communicate the most recent version on our website (www.chapps.com) and invite you to consult it regularly. The date of the 
    last change is at the top of this document. Older versions are stored in our archives.<br/>
    Of course, we inform you via our websites or other common communication channels of any change in content.</p>

    <p>If you do not agree to a change, the Applications can no longer be used. You must then remove the installation from your device 
    and stop visiting and using the Applications.</p>


    <h3>12. Various provisions</h3>
    
    <p>You hereby state and warrant that (i) you are not in a country subject to an embargo by the U.S. Government or designated by the U.S. 
    Government as a country supporting "terrorism" and (ii) you are not on any U.S. Government list of persons subject to any prohibition or restriction.</p>

    <p>If any provision of this License Agreement is invalid or unenforceable under any applicable law, that will not affect the validity or enforceability 
    of the remainder of the provisions of this License Agreement. Without further action by the parties to this Agreement, such provision shall be amended to 
    the extent possible to make it valid and enforceable.</p>

    <p>Any failure by Chapps not to enforce any provision of this License Agreement shall not be deemed to constitute a waiver of these provisions and shall 
    in no way affect its rights to enforce any provision of this License Agreement at a later date.</p>

    <p>Regardless of the country from which you open the Applications, your use of the Applications will always be governed by Belgian law. In the event of 
    any dispute arising out of, or in connection with, this License Agreement, including any questions regarding its existence, validity or termination, 
    and/or arising out of, or in connection with, access to or use of the Applications, the courts of Brussels (Belgium) will have exclusive jurisdiction.</p>
    
    
    <h3>13. Contact</h3>

    <p>If you have any questions or concerns about these Licensing Terms, you can always contact us via <a href="mailto:info@chapps.com">info@chapps.com</a> .</p>
    `
}